import { render, staticRenderFns } from "./MenuPopup.vue?vue&type=template&id=1959b689&"
import script from "./MenuPopup.vue?vue&type=script&lang=js&"
export * from "./MenuPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports